import { render, staticRenderFns } from "./MyDownloads.vue?vue&type=template&id=4ba680ac&scoped=true&"
import script from "./MyDownloads.vue?vue&type=script&lang=js&"
export * from "./MyDownloads.vue?vue&type=script&lang=js&"
import style0 from "./MyDownloads.vue?vue&type=style&index=0&id=4ba680ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba680ac",
  null
  
)

export default component.exports